import type { CSSProperties } from 'react';

type EmblemProps = {
  size?: number;
  mono?: boolean;
  invert?: boolean;
  style?: CSSProperties;
};

export function Emblem({ size = 120, mono = false, invert = false, style }: EmblemProps) {
  const filter = invert
    ? 'invert(1) hue-rotate(180deg)'
    : mono
      ? 'grayscale(1) brightness(.2)'
      : 'none';
  return (
    <img
      src="/logo.png"
      alt="Operacja Teneryfa"
      style={{ width: size, height: 'auto', display: 'block', filter, ...style }}
    />
  );
}
